<template>
  <div class="app-mini-card" @click="handleClick">
    <div class="app-mini-card__name">{{ name }}</div>
    <div class="app-mini-card__description">{{ description }}</div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['app_selected']);

function handleClick() {
  emit('app_selected', props.name);
}
</script>

<style scoped lang="scss">
.app-mini-card {
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  background-color: #ffffff;
  transition: all 0.2s ease;

  &:hover {
    border-color: #0066cc;
    box-shadow: 0 2px 8px rgba(0, 102, 204, 0.1);
  }

  &__name {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 8px;
    color: #333333;
  }

  &__description {
    font-size: 12px;
    color: #666666;
    line-height: 1.4;
  }
}
</style>
